module.exports = __webpack_public_path__ + "img/logo1.c72202c3.svg";